import showMessage from "../common/showMessage";

const handleRequestSuccess = (contactForm) => () => {
  contactForm.querySelector("button[type='submit']").classList.remove("loading");
  contactForm.querySelector("button[type='submit']").removeAttribute("disabled");
  showMessage.thankyou(contactForm, "お問い合わせありがとうございます。<br>メッセージの送信を完了しました。");
};

export default handleRequestSuccess;
